import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";

import { CartContext } from "../CartContext";
import { getData } from "../Api";

const BlogCarts = ({ slug }) => {
  const [product, setProduct] = useState(null);
  const navigate = useNavigate();
  const { addToCart } = useContext(CartContext);

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const response = await getData(`/product/${slug}`);
        setProduct(response.data);
      } catch (error) {
        console.error("Error fetching product:", error);
      }
    };

    fetchProduct();
  }, [slug]);

  const handleBuyNow = async () => {
    if (!product) return;
    await addToCart({ ...product, quantity: 1 });
    navigate("/checkout");
  };

  if (!product) return <p>Loading...</p>;

  return (
    <div className="card blogcart765 text-white p-2 d-flex flex-row align-items-center">
      <img
        src={
          product.image
            ? `${product.image}`
            : "https://via.placeholder.com/100"
        }
        alt={product.title}
        className="img-fluid rounded me-3"
        style={{ width: "140px", height: "140px", objectFit: "cover" }}
      />

      <div className="flex-grow-1">
        <h5 className="mb-1">
          {product.title}
          <span className="float-end">
            <del className="text-muted">₹{product.price}</del>
            <strong> ₹{product.discount_price}</strong>
          </span>
        </h5>

        <div
          className="py-3"
          dangerouslySetInnerHTML={{ __html: product.short_description }}
        ></div>

        <button
          className="btn btn-light btn-sm float-end"
          onClick={handleBuyNow}
        >
          Buy Now
        </button>
      </div>
    </div>
  );
};

export default BlogCarts;
